module.exports = __webpack_public_path__ + "img/image-5.a4125d3c.jpg";